var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboardWrapper" },
    [
      _c("CustomDashboard", {
        key: _vm.partner?._id,
        attrs: { iframe: _vm.iframe },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }